<!-- 推广账户管理 - 头条巨量引擎 -->
<template>
<div>
	<div style="display: flex;align-items: center;">
		<div v-for="(item,index) in titleTab" :key="index" 
		:class="{'title-tab-box-selected': item.select}" 
		@click="changeTab(item,index)"
		class="title-tab-box">{{item.label}}</div>
	</div>
	
	<div v-show="content_type == 0">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0 0;">
			<div class="screen-box">
				<div class="screen-label">推广账户名称</div>
				<a-input v-model="r_adv_name" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">负责人</div>
				
				<adminSelect @handleChangeSelect="handleChangeA"></adminSelect>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">开发者账户</div>
				<a-select
					showSearch
					style="min-width: 200px"
					placeholder="请选择开发者账户"
					@change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in ToutiaoList" :key="item.id" :value="item.id" :title="item.account_name">
					  {{item.account_name}}
					</a-select-option>
				</a-select>
			</div>
			
			<!-- <div class="screen-box">
				<div class="screen-label">书城频道</div>
				<a-select
					showSearch
					style="min-width: 160px"
					placeholder="请选择书城频道"
					@change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterData.book_type.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">书城形式</div>
				<a-select
					showSearch
					style="min-width: 160px"
					placeholder="请选择书城形式"
					@change="handleChangeG"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="1">加粉</a-select-option>
					<a-select-option value="2">快应用</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">书城渠道</div>
				<a-select
					showSearch
					style="min-width: 180px"
					placeholder="请选择书城渠道"
					@change="handleChangeH"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterData.channel_id.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div> -->
			
			<div class="screen-box">
				<div class="screen-label">公司主体</div>
				<a-select
					showSearch
					style="width: 300px"
					placeholder="请选择公司主体"
					@change="handleChangeZ"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in companySelect" :key="index" :value="item.company_name" :title="item.company_name">
					  {{item.company_name}}
					</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>
			<a-button @click="showPlAccID()" class="screen-box" type="primary">批量搜索账户ID</a-button>
			<a-button class="screen-box" @click="setFZR" type="primary">批量设置负责人（已选{{selectedData.length}}项）</a-button>
		</div>

		<div>
			<!-- 表头 -->
			<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
				<div class="table-th-cell"
				:style="{'width':40 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				
				<div  v-for="(item,index) in rableTitle" :key="index" >
					<div class="table-th-cell" 
					:style="{'width':item.width + 'px',}">
						{{item.title}}
					</div>
				</div>
			</div>
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':40 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<!-- 推广账户名称 -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.adv_name}}
				</div>
				<!-- 推广账户ID -->
				<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.adv_id}}
				</div>
				<!-- 负责人 -->
				<div  @click="setFZRShow(item)"  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					<div v-if="item.auth.length > 0" style="display: flex;align-items: center;flex-wrap: wrap;cursor: pointer;">
						<div v-for="(item,index) in item.auth" :key="index" style="color: #2F88FF;margin: 0 10px 5px 0">
							{{item.admin_name}}
						</div>
					</div>
					<div v-else style="color: #62a8ea;cursor: pointer;">
						未设置
					</div>
				</div>
				<!-- 开发者账户 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
					{{item.account.account_name}}
				</div>
				<!-- 投放参数 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
					<div style="display: flex;align-items: center;">
						<div style="flex-shrink: 0;">投放域名：</div>
						<div v-if="item.domain">{{item.domain.url || "未设置"}}</div>
						<div v-else>未设置</div>
					</div>
					
					<div style="display: flex;align-items: center;">
						<div style="flex-shrink: 0;">审核公司：</div>
						<div>{{item.company_name || "未设置"}}</div>
					</div>
					
					<div style="display: flex;align-items: center;">
						<div style="flex-shrink: 0;">广告来源：</div>
						<div>{{item.source || "未设置"}}</div>
					</div>
				</div>
				<!-- 频道 -->
				<!-- <div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
					{{item.book_type}}
				</div> -->
				<!-- 书城形式 -->
				<!-- <div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
					{{item.book_fun}}
				</div> -->
				<!-- 书城渠道 -->
				<!-- <div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
					{{item.channel_name}}
				</div> -->
				<!-- 公司主体 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
					{{item.company_name}}
				</div>
				<!-- 操作 -->
				<div class="table-td-cell" :style="{'width': rableTitle[6].width + 'px'}" >
					
					<div @click="editTable(index,item)" style="color: #62a8ea;cursor: pointer;margin-bottom: 7px;">设置投放参数</div>
					<!-- <div @click="editGH(item)" style="color: #62a8ea;cursor: pointer;">推广内容规划</div> -->
				</div>
			</div>
			
			<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_scroll_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	</div>
	<div v-show="content_type == 1" style="margin-top: 30px;">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width_c - 60 + 'px'}">
			
			<div  v-for="(item,index) in rableTitleBBB" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in ToutiaoList" :key="index" class="table-td"  :style="{'width': table_scroll_width_c -60 + 'px'}">
			<!-- 开发者账户 -->
			<div class="table-td-cell" :style="{'width':rableTitleBBB[0].width + 'px'}">
				{{item.account_name}}
			</div>
			<!-- APPID -->
			<div  class="table-td-cell" :style="{'width':rableTitleBBB[1].width + 'px'}">
				{{item.appid}}
			</div>
			<!-- SECRET -->
			<div  class="table-td-cell" :style="{'width':rableTitleBBB[2].width + 'px'}">
				{{item.secret}}
			</div>
			<!-- 操作 -->
			<div class="table-td-cell" :style="{'width': rableTitleBBB[3].width + 'px'}" style="color: #62a8ea;">
				<div style="display: flex;align-items: center;">
					<div @click="TBclick('同步子账户',item)" style="cursor: pointer;margin-right: 15px;">同步子账户</div>
					<div @click="TBclick('同步广告主',item)" style="cursor: pointer;margin-right: 15px;">同步广告主</div>
					<div @click="devEdit(item)" style="cursor: pointer;margin-right: 15px;">编辑</div>
				</div>
				
			</div>
		</div>
		
		<div v-show="ToutiaoList.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
	</div>
	
	<!-- 批量设置负责人 -->
	<a-modal :visible="pl_modal" title="批量设置负责人" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的负责人</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择负责人"
					@change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
					:value="fzr_user"
				  >
					<a-select-option v-for="(value,key) in personChargeList" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 120px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 15px;">{{item.label}}</div>
					<!-- <div @click="delSelectFZR(index)" style="color: red;cursor: pointer;">删除</div> -->
					<a-icon @click="delSelectFZR(index)" type="close-circle" />
				</div>
			</div>
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的内容：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 105px;">{{item.adv_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  title="设置投放参数"
	  width="700px"
	  placement="right"
	  :closable="false"
	  :visible="drawer_visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">投放域名</div>
				<a-select
					:value="x_put_url"
				    style="width: 320px"
				    placeholder="请选择"
				    @change="handleChangeE"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
				    <a-select-option v-for="(item,key) in ToutiaoList" :key="key" :value="key">
				      {{item.account_name}}
				    </a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">审核公司</div>
					
				<a-input v-model="x_company_name" placeholder="请输入" style="width: 320px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">广告来源</div>
					
				<a-input v-model="x_source" placeholder="请输入" style="width: 320px;"  />
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 开发者账户管理 编辑的侧边栏 -->
	<a-drawer
	  title="设置投放参数"
	  width="600px"
	  placement="right"
	  :closable="false"
	  :visible="dev_edit_visible"
	  @close="onCloseDev"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">开发者账户名称</div>
					
				<a-input v-model="dev_account_name" placeholder="请输入" style="width: 350px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">账户appid</div> 
					
				<a-input v-model="dev_appid" placeholder="请输入" style="width: 350px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">账户secret</div>
					
				<a-input v-model="dev_secret" placeholder="请输入" style="width: 350px;"  />
			</div>
			
			<!-- <div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div> -->
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="devAddRequest" :loading="dev_add_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDev">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 设置推广内容规划的侧边栏 -->
	<a-drawer
	  title="设置推广内容规划"
	  width="550px"
	  placement="right"
	  :closable="false"
	  :visible="gh_drawer_visible"
	  @close="onCloseDrawerGH"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">书城频道<span class="required-hint">*</span></div>
				<a-select
					:value="e_book_type"
				    style="width: 240px"
				    placeholder="请选择"
				    @change="handleChangeE"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					
				  >
				    <a-select-option v-for="(item,index) in filterData.book_type.list" :key="item.key" :value="item.key">
				      {{item.value}}
				    </a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">书城形式<span class="required-hint">*</span></div>
				<a-select
					:value="e_book_fun"
				    style="width: 240px"
				    placeholder="请选择"
				    @change="handleChangeJ"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					
				  >
				    <a-select-option value="1">加粉</a-select-option>
				    <a-select-option value="2">快应用</a-select-option>
				</a-select>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">书城渠道</div>
				<a-select
					:value="e_channel_id"
				    style="width: 240px"
				    placeholder="请选择"
				    @change="handleChangeK"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
				    <a-select-option v-for="(item,index) in filterData.channel_id.list" :key="item.key" :value="item.key">
				      {{item.value}}
				    </a-select-option>
				</a-select>
			</div>
			
			<div style="color: red;height: 23px;width: 100%;">{{gh_form_hint}}</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequestGH" :loading="gh_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawerGH">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 批量搜索账户ID -->
	<plSearchID ref="refPlSearchID" @get-pl-id="getPlId"></plSearchID>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import plSearchID from "./components/plSearchID"
import adminSelect from "./components/adminSelect"
import { putUserList, putUserToutiaoList, putAdvList, putSetAdvUser, putSetAdvPut, syncMarketing, editToutiaoAccount, putDataMenu, putSetPlan, getCommonSelectAdvCompany } from '@/request/api'
export default {
	name: 'accountTT_',
	components: {
		plSearchID,adminSelect
	},
	data() {
		return {
			titleTab: [
				{label: "推广账户管理", select: true , value: 0 },
				{label: "开发者账户管理", select: false , value: 1 },
			],
			content_type: 0, // 页面内容展现类型
			
			personChargeList: {}, // 负责人列表
			ToutiaoList: [], // 开发者账户
			
			r_adv_name: null, // 推广账户名称
			r_admin_id: null, // 负责人id
			r_account_id: "", // 开发者账户id
			r_page: 1,
			r_limit: 100,
			table_total: 0,
			r_book_type: undefined, // 书城频道
			r_book_fun: undefined, // 书城形式
			r_channel_id: undefined, // 渠道
			r_company_name: null, // 公司主体
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"推广账户名称", width:130, type:"adv_name", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"推广账户ID", width:150, type:"adv_id", },
				{title:"负责人", width:130, type:"auth", },
				{title:"开发者账户", width:160, type:"account_name", },
				{title:"投放参数", width:220, type:"appid", },
				// {title:"频道", width:80, type:"book_type", },
				// {title:"书城形式", width:100, type:"book_fun", },
				// {title:"书城渠道", width:100, type:"channel_name", },
				{title:"公司主体", width:130, type:"company_name", },
				{title:"操作", width:120, type:"cz", },
			],
			tableShowData: [],
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1000,
			table_scroll_width_c: 1000,
			search_button_loading: false,
			rableTitleBBB: [
				{title:"开发者账户", width:220, type:"account_name", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"APPID", width:200, type:"appid", },
				{title:"SECRET", width:320, type:"secret", },
				{title:"操作", width:260, type:"cz", },
			],
			tableShowDataBBB: [],
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量设置负责人
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			
			// 设置参数侧边栏
			drawer_visible: false,
			add_button_loading: false, // 侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_company_name: "", // 审核公司
			x_id: "", // 
			x_put_url: undefined, // 投放域名
			x_source: "", // 广告来源
			
			dev_edit_visible: false, 
			dev_account_name: "", // 开发者账户名称
			dev_appid: "", // dev_appid
			dev_secret: "", // dev_secret
			dev_id: "",
			
			dev_add_loading: false,
			
			// 设置推广内容规划侧边栏
			gh_drawer_visible: false, // 设置推广内容规划侧边栏显示与否
			gh_form_hint: "", 
			gh_button_loading: false, 
			
			
			// 筛选条件部分
			filterData: {
				op_id:{
					list: [{}],
				},
				media_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				gzh_id:{
					list: [{}],
				},
				book_type: {
					list: [{}],
				}
				
			}, // 筛选条件数组
			
			e_id: "",
			e_book_type: undefined, // 设置推广内容规划- 书城频道
			e_book_fun: undefined, // 设置推广内容规划- 书城形式
			e_channel_id: undefined, // 设置推广内容规划- 书城渠道
			
			// 批量搜索账户ID
			pl_text_content: [], // 批量粘贴过来，分隔过后的数据
			
			fzr_user: undefined,
			
			companySelect: [], // 公司主体下拉
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle, 40)
		let table_info_c = this.$getTableInfo(that.rableTitleBBB)
		that.table_scroll_width = table_info.table_width - 40 // 上一级的一个大盒子有一个左右的内边距，-60就是为了消除这个边距（并不是最外面盒子的边距）
		that.table_scroll_width_c = table_info_c.table_width
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 负责人
		putUserList().then(res=>{
			console.log("负责人",res);
			that.personChargeList = res.data.data.list
		})
		
		putDataMenu().then(res=>{
			that.filterData = res.data.data.filter
		})
		
		// 开发者账户
		putUserToutiaoList().then(res=>{
			console.log("开发者账户",res);
			if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
				that.ToutiaoList = res.data.data.data
			}
			else {
				that.ToutiaoList = []
				that.$message.error(`开发者账户-错误：${res.data.msg}`);
			}
		})
		
		getCommonSelectAdvCompany().then(res=>{
			console.log("公司主体下拉",res)
			that.companySelect = res.data.data.list || []
		})
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				this.searchButton('button')
			}
			console.log(this.content_type)
		},
		handleChangeA(e){
			this.r_admin_id = e
		},
		handleChangeB(e){
			this.r_account_id = e 
		},
		// 书城频道
		handleChangeC(e){ 
			this.r_book_type = e
		},
		// 书城形式
		handleChangeG(e){ 
			this.r_book_fun = e
		},
		// 书城渠道
		handleChangeH(e){ 
			this.r_channel_id = e
		},
		
		// 批量设置负责人
		handleChangeD(e){
			console.log(e);
			this.fzr_user = e
			let ttt = true
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		handleChangeE(e){
			console.log(e);
			this.x_put_url = e
		},
		// 公司主体
		handleChangeZ(e){
			this.r_company_name = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			
			that.search_button_loading = true
			
			if(type != '分页'){
				that.selectedData = [] // 已选内容清空
			}
			
			if(type == 'button'){
				that.r_page = 1
			}
			if(that.content_type == 0){ // 推广账户管理
				let r_data = {
					page: that.r_page,
					limit: that.r_limit,
					adv_name: that.r_adv_name, // 推广账户名称
					admin_id: that.r_admin_id, // 负责人id
					account_id: that.r_account_id, // 开发者账户id
					book_type: that.r_book_type, // 书城频道
					book_fun: that.r_book_fun, // 书城形式
					channel_id: that.r_channel_id, // 渠道
					company_name: that.r_company_name, // 公司主体
				}
				if(type == '批量账户ID'){
					r_data.adv_id = that.pl_text_content
				}
				putAdvList(r_data).then(res=>{
					console.log("搜索",res);
					
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						let data = res.data.data.data
						data.forEach(res=>{
							res.checked = false // 用于多选和单选
							
						})
						
						if(that.selectedData.length > 0){
							let ccc = true
							let iii = 0 // 用于判断是否全选
							data.forEach(res=>{
								that.selectedData.forEach(res_r=>{
									if(res.id === res_r.id){
										res.checked = true
										ccc = false
										iii = iii + 1
									}
								})	
							})
							console.log("iii",iii)
							if(iii === 20){ // 全选
								that.indeterminate = false
								that.checkAll = true
							}
							else {
								if(ccc){
									that.checkAll = false
									that.indeterminate = false
								}
								else {
									that.checkAll = false
									that.indeterminate = true
								}
							}
							
						}
						else {
							console.log("that.checkAll",that.checkAll)
							that.checkAll = false
							that.indeterminate = false
						}
						
						that.search_button_loading = false
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total
						that.tableShowData = data
					}
					else {
						that.search_button_loading = false
						that.checkAll = false
						that.indeterminate = false
						that.selectedData = []
						that.tableShowData.forEach(res=>{
							res.checked = false
						})
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
				})
			}
			else if(that.content_type == 1){ // 开发者账户管理
				// 开发者账户
				putUserToutiaoList().then(res=>{
					console.log("开发者账户",res);
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.ToutiaoList = res.data.data.data
					}
					else {
						that.ToutiaoList = []
						that.$message.error(`开发者账户-错误：${res.data.msg}`);
					}
				})
			}
		},
		// 批量设置负责人
		setFZR(){
			if(this.selectedData.length > 0){
				this.pl_modal = true
			}
			else {
				this.$message.warning('请先选择内容');
			}
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton('分页')
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		// 设置负责人
		setFZRShow(e){
			let that = this
			this.selectedData = []
			this.selectedData.push(e)
			console.log(e);
			e.auth.forEach(res=>{
				let obj = {
					label: res.admin_name,
					key: res.admin_id
				}
				this.pl_select_admin.push(obj)
			})
			this.pl_modal = true
		},
		
		// 批量设置负责人
		plOk(){
			let that = this
			if(that.pl_select_admin.length > 0){ // 得选择设置负责人
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.id)
				})
				console.log("i_data",i_data);
				
				putSetAdvUser({
					admin_id: a_data,
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					console.log("批量设置设置负责人",res);
					that.selectedData = []
					that.plCancel()
					that.$message.success('设置成功');
					that.searchButton()
				})
			}
			else {
				this.$message.warning('请先选择设置负责人');
			}
			
			
		},
		// 批量设置管理员弹窗取消按钮
		plCancel(){
			// if(this.pl_loading){
			// 	return 
			// }
			
			this.pl_modal = false
			this.pl_select_admin = []
			this.pl_loading = false
			
			this.fzr_user = undefined
		},
		// 删除选择的负责人
		delSelectFZR(index){
			this.pl_select_admin.splice(index,1)
		},
		
		// 设置投放参数
		editTable(index,e){
			console.log(e);
			this.x_id = e.id
			
			this.x_company_name = e.company_name || "" // 审核公司
			if(e.domain){
				this.x_put_url = e.domain.id || undefined // 投放域名
			}
			else {
				this.x_put_url = undefined
			}
			this.x_source = e.source || "", // 广告来源
			
			this.drawer_visible = true
		},
		// 侧边栏确认按钮
		addRequest(){
			let that = this
			that.add_button_loading = true
			putSetAdvPut({
				company_name: that.x_company_name,
				id: that.x_id,
				put_url: that.x_put_url,
				source: that.x_source
			}).then(res=>{
				that.add_button_loading = false
				console.log("设置投放参数",res);
				that.onCloseDrawer()
				that.$message.success('设置成功');
				that.searchButton()
			})
		},
		// 设置投放参数侧边栏关闭
		onCloseDrawer(){
			if(this.add_button_loading){
				return
			}
			this.x_company_name = "", // 审核公司
			this.x_id = "", // 
			this.x_put_url = undefined, // 投放域名
			this.x_source = "", // 广告来源
			this.drawer_visible = false
		},
		
		// 同步
		TBclick(e,item){
			let that = this
			that.search_button_loading = true
			let ttt
			if(e == '同步子账户'){
				ttt = "son"
			}
			else if(e == '同步广告主'){
				ttt = "son-adv"
			}
			console.log(item);
			syncMarketing({
				id: item.id,
				type: ttt
			}).then(res=>{
				that.search_button_loading = false
				console.log('同步',res);
				that.$message.success(res.data);
			})
		},
		devEdit(e){
			let that = this
			console.log(e);
			
			that.dev_account_name = e.account_name
			that.dev_appid = e.appid
			that.dev_id = e.id
			that.dev_secret = e.secret
			
			that.dev_edit_visible = true
			
		},
		devAddRequest(){
			let that = this
			that.dev_edit_visible = true
			editToutiaoAccount({
				account_name: that.dev_account_name,
				appid: that.dev_appid,
				id: that.dev_id,
				secret: that.dev_secret
			}).then(res=>{
				console.log("开发者编辑",res);
				that.onCloseDev()
				that.$message.success('设置成功');
				// 开发者账户
				that.search_button_loading = true
				putUserToutiaoList().then(res=>{
					console.log("开发者账户",res);
					that.search_button_loading = false
					
					that.ToutiaoList = res.data.data.data
				})
			})
		},
		onCloseDev(){
			if(this.dev_add_loading){
				return
			}
			this.dev_edit_visible = false
		},
		
		
		// 设置推广内容规划侧边栏
		editGH(e){
			console.log(e);
			this.e_id = e.id
			this.e_book_type = e.book_type || undefined, // 设置推广内容规划- 书城频道
			this.e_book_fun = e.book_fun || undefined, // 设置推广内容规划- 书城形式
			this.e_channel_id = e.channel_id || undefined, // 设置推广内容规划- 书城渠道
			this.gh_drawer_visible = true
			
		},
		addRequestGH(){
			let that = this
			if(that.e_book_type == undefined){
				that.$message.warning('请选择书城频道');
			}
			else if(that.e_book_fun == undefined){
				that.$message.warning('请选择书城形式');
			}
			else {
				that.gh_button_loading = true
				putSetPlan({
					book_type: that.e_book_type, // 书城频道
					book_fun: that.e_book_fun, // 书城形式
					channel_id: that.e_channel_id, // 书城渠道
					id: that.e_id
				}).then(res=>{
					console.log("推广内容规划",res);
					that.gh_button_loading = false
					if(res.data.code == 0){
						that.onCloseDrawerGH()
						that.$message.success('操作成功');
						that.searchButton()
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
					
				})
			}
			
			
		},
		onCloseDrawerGH(){
			this.e_id = "",
			this.e_book_type = undefined, // 设置推广内容规划- 书城频道
			this.e_book_fun = undefined, // 设置推广内容规划- 书城形式
			this.e_channel_id = undefined, // 设置推广内容规划- 书城渠道
			this.gh_drawer_visible = false
		},
		handleChangeE(e){ // 设置推广内容规划- 书城频道
			this.e_book_type = e
		},
		handleChangeJ(e){ // 设置推广内容规划- 书城形式
			this.e_book_fun = e
		},
		handleChangeK(e){ // 设置推广内容规划- 书城渠道
			console.log("设置推广内容规划- 书城渠道",e);
			this.e_channel_id = e
		},
		
		// 批量搜索账户ID
		showPlAccID(){
			this.$refs.refPlSearchID.plAccountID()
		},
		getPlId(ttt){
			this.pl_text_content = ttt
			this.searchButton('批量账户ID')
		}
	},
}	
</script>

<style scoped>


.class-title {
	width: 100px;
}
</style>